// components/PrivacyFlow/PrivacyShell.jsx
import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { HashRouter, MemoryRouter, Routes, Route } from 'react-router-dom';
import ApplicationUnavailablePage from './components/common/ApplicationUnavailablePage';
import ErrorBoundary from './components/common/ErrorBoundary';
import PrivacyHomepage from './components/PrivacyFlow/PrivacyHomepage';
import PreferencePage from './components/PrivacyFlow/PreferencePage';
import ConfirmPage from './components/PrivacyFlow/ConfirmPage';
import { isSupportedCountry } from './utils/ModuleMap';
import { OCCProvider } from './components/OCCFlow/context/occContext';
import OCCThankYouPage from './components/OCCFlow/OCCThankyou';
import OCCCancelPage from './components/OCCFlow/OCCCancelPage';
import OCCErrorPage from './components/OCCFlow/occErrorPage';
import OCCCancelSettingsPage from './components/OCCFlow/OCCCancelOptout';
import OCCPreferenceThankPage from './components/OCCFlow/OCCPreferenceThankPage';
import OCCUnsubscribePage from './components/OCCFlow/OCCUnsubscribePage';
import OCCPreferencePage from './components/OCCFlow/OCCPreferencePage';

/*
  This component is mounted at /privacy/:country (e.g. /privacy/australia/)
  It uses HashRouter so the browser URL looks like:
    /privacy/australia/#/ipp
    /privacy/australia/#/ipp/preferences
*/

const getCountryFromPathname = (pathname = '') => {
  const [, modulePath, country] = pathname.split('/');
  if (modulePath !== 'privacy') {
    return '';
  }
  return (country || '').toLowerCase();
};
const PrivacyShell = ({
  location = {}
}) => {
  var _window, _window2;
  useEffect(() => {
    if (typeof document !== 'undefined' && !document.title) {
      document.title = 'Email Marketing Preferences';
    }
  }, []);
  const isBrowser = typeof document !== 'undefined';
  const pathname = location.pathname || (typeof window !== 'undefined' ? (_window = window) === null || _window === void 0 || (_window = _window.location) === null || _window === void 0 ? void 0 : _window.pathname : '');
  const hashPath = (location.hash || (typeof window !== 'undefined' ? (_window2 = window) === null || _window2 === void 0 || (_window2 = _window2.location) === null || _window2 === void 0 ? void 0 : _window2.hash : '') || '#/ipp').replace(/^#/, '') || '/ipp';
  const country = getCountryFromPathname(pathname);
  if (country && !isSupportedCountry(country)) {
    return /*#__PURE__*/React.createElement(ApplicationUnavailablePage, null);
  }
  const routes = /*#__PURE__*/React.createElement(ErrorBoundary, null, /*#__PURE__*/React.createElement(Routes, null, /*#__PURE__*/React.createElement(Route, {
    path: "/ipp",
    element: /*#__PURE__*/React.createElement(PrivacyHomepage, null)
  }), /*#__PURE__*/React.createElement(Route, {
    path: "/ipp/error",
    element: /*#__PURE__*/React.createElement(ApplicationUnavailablePage, null)
  }), /*#__PURE__*/React.createElement(Route, {
    path: "/ipp/preferences",
    element: /*#__PURE__*/React.createElement(PreferencePage, null)
  }), /*#__PURE__*/React.createElement(Route, {
    path: "/ipp/confirm",
    element: /*#__PURE__*/React.createElement(ConfirmPage, null)
  }), /*#__PURE__*/React.createElement(Route, {
    path: "/occ",
    element: /*#__PURE__*/React.createElement(OCCProvider, null)
  }, /*#__PURE__*/React.createElement(Route, {
    path: "mktemailoptout",
    element: /*#__PURE__*/React.createElement(OCCUnsubscribePage, null)
  }), /*#__PURE__*/React.createElement(Route, {
    path: "optout",
    element: /*#__PURE__*/React.createElement(OCCPreferencePage, null)
  }), /*#__PURE__*/React.createElement(Route, {
    path: "surveysresearchNLTY",
    element: /*#__PURE__*/React.createElement(OCCThankYouPage, null)
  }), /*#__PURE__*/React.createElement(Route, {
    path: "surveysresearchNLCancel",
    element: /*#__PURE__*/React.createElement(OCCCancelPage, null)
  }), /*#__PURE__*/React.createElement(Route, {
    path: "optouterror",
    element: /*#__PURE__*/React.createElement(OCCErrorPage, null)
  }), /*#__PURE__*/React.createElement(Route, {
    path: "cancelProductNewsletter",
    element: /*#__PURE__*/React.createElement(OCCCancelSettingsPage, null)
  }), /*#__PURE__*/React.createElement(Route, {
    path: "updateProductNewsletter",
    element: /*#__PURE__*/React.createElement(OCCPreferenceThankPage, null)
  })), /*#__PURE__*/React.createElement(Route, {
    path: "*",
    element: /*#__PURE__*/React.createElement(ApplicationUnavailablePage, null)
  })));
  if (isBrowser) {
    return /*#__PURE__*/React.createElement(HashRouter, null, routes);
  }
  return /*#__PURE__*/React.createElement(MemoryRouter, {
    initialEntries: [hashPath]
  }, routes);
};
export default PrivacyShell;